import { useLocation, useNavigate } from 'react-router-dom';

export function useLocationHash(value: string) {
  const navigate = useNavigate();
  const { hash } = useLocation();

  const state = hash.startsWith(value);
  const setState = (toggled: boolean) => {
    if (toggled) {
      // Preserve any existing suffix (e.g., ":personal") when enabling
      const suffix = hash.startsWith(value) ? hash.slice(value.length) : '';
      navigate({ hash: `${value}${suffix}` }, { replace: true });
    } else {
      navigate({ hash: '' }, { replace: true });
    }
  };

  return [state, setState] as [typeof state, typeof setState];
}
